/* eslint-disable @typescript-eslint/no-explicit-any */
import ReactMarkdown from 'react-markdown';

import styles from './markdown-block.module.css';

import Link from 'next/link';
import { Text } from '@radix-ui/themes';

const components = {
  a(props: any) {
    const { href, children } = props;
    return (
      <Link
        href={href}
        className={styles.Link}
      >
        {children}
      </Link>
    );
  },
  p(props: any) {
    const { children } = props;
    return (
      <Text
        as='div'
        size='2'
      >
        {children}
      </Text>
    );
  }
};

interface Props {
  markdown: string;
}
const MarkdownBlock = ({ markdown }: Props) => {
  return <ReactMarkdown components={components}>{markdown}</ReactMarkdown>;
};

export default MarkdownBlock;
